import { useMemo } from 'react';
import TrailCard from 'components/cards/TrailCard';
import { Context } from '@alltrails/shared/types/context';
import { Trail } from 'types/Trails';
import * as styles from './styles/styles.module.scss';
import River from '../../shared/River';
import ShowMoreCard from './ShowMoreCard';
import TrailRiverShimmer from '../../shimmers/TrailRiverShimmer';
import { HOME_PAGE_WIDTH_BREAKPOINT } from '../../../utils/constants/breakpoints';
import { ListMethods } from '../../../types/ListItems';

const slickSettings = { slidesToShow: 4, lazyLoad: 'progressive', slidesToScroll: 4, speed: 750 };
const ARROW_STYLES = { next: styles.next, previous: styles.previous };

type HitTrail = Trail & { exploreMoreUrl: string };

export type Props = {
  hits: HitTrail[];
  title: string;
  windowWidth: number;
  context: Context;
  className?: string;
  listMethods: ListMethods;
};

const TrailRiver = ({ hits, title, windowWidth, context, className, listMethods }: Props): JSX.Element => {
  const isWideScreen = useMemo(() => windowWidth && windowWidth >= HOME_PAGE_WIDTH_BREAKPOINT, [windowWidth]);

  if (!hits) {
    return <TrailRiverShimmer className={className} />;
  }

  return (
    <div className={`${styles.container} ${className}`}>
      <div className={`${styles.title} xlate-none`}>{title}</div>
      <div className={styles.riverContainer}>
        <River useSlick={isWideScreen} slickSettings={slickSettings} className={styles.riverClass} arrowStyles={ARROW_STYLES}>
          {hits.map(hit => (
            <div className={styles.trailCardContainer} data-testid={`${title}`} key={hit.ID || hit.exploreMoreUrl}>
              {hit.exploreMoreUrl ? (
                <ShowMoreCard url={hit.exploreMoreUrl} />
              ) : (
                <TrailCard
                  context={context}
                  className={styles.trailCard}
                  allowItemMoving={false}
                  handleFavoriteClick={() => listMethods.handleFavoriteClick(hit.type, hit.ID, hit.objectID)}
                  isCompleted={listMethods.isComplete(hit.type, hit.ID)}
                  isFavorite={listMethods.isFavorite(hit.type, hit.ID)}
                  isVerified={listMethods.isVerified(hit.type, hit.ID)}
                  key={`trail-${hit.ID}`}
                  trail={hit}
                  maxPhotos={1}
                />
              )}
            </div>
          ))}
        </River>
      </div>
    </div>
  );
};

export default TrailRiver;
